import React from 'react';
import { connect } from 'react-redux';
import { fetchNewsModel } from './InvestmentPage.action';
import InvestmentPage from './InvestmentPage';

class InvestmentPageContainer extends React.Component {
    constructor(props) {
        super(props);
        this.props.fetchData();
    }
    render() {
        return (
            <InvestmentPage {...this.props} />
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchData: () => dispatch(fetchNewsModel())
    }

}
const mapStateToProps = state => {
    return {
        result: state.InvestmentReducer.result
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(InvestmentPageContainer);